import React, { useState } from "react";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useSelector } from "react-redux";
import { getImageFullUrl, pageRoute } from "../utils/common";

export default function ProfileMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const {logout} = useAuth()

  const user = useSelector((state) => state.user);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleGoProfile = () => {
    handleMenuClose();
    navigate(pageRoute.profile); 
  };

  const handleLogout = () => {
    handleMenuClose();
    logout()
  };

  return (
    <Box>
      <IconButton onClick={handleMenuOpen} size="small" sx={{ ml: 2 }}>
        <Avatar alt={user?.fullName} src={getImageFullUrl(user?.profileImage)} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* ✅ Profile Info in Menu */}
        <Box sx={{ px: 2, py: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar alt={user?.fullName} src={getImageFullUrl(user?.profileImage)} />
          <Box>
            <Typography variant="subtitle1">{user?.fullName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {user?.email}
            </Typography>
          </Box>
        </Box>
        <Divider />

        {/* ✅ Menu Options */}
        <MenuItem onClick={handleGoProfile}>Profile</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </Box>
  );
}
